<template>
  <ul class="list">
    <CardItem v-for="item in list" :key="item.id" :info="item" />
  </ul>
</template>

<script>
import { apiCourseList } from '@/api/IELTScourse'
import CardItem from '../components/cardItem'

export default {
  components: {
    CardItem
  },
  data() {
    return {
      list: []
    }
  },
  created() {
    this.fetchList()
  },
  methods: {
    async fetchList() {
      const { data } = await apiCourseList({
        page: 1,
        page_size: 999999
      })
      this.list = data.list || []
    }
  }
}
</script>

<style scoped lang="scss">
.list {
  margin: 0 -12px;
  display: flex;
  flex-wrap: wrap;
}
</style>
